const getBarColor = (v) => {
  if (v >= 95) return "#009F52";
  if (v >= 80) return "#1D9E75";
  if (v >= 70) return "#FFC100";
  return "#FB0301";
};

function KPISection({ data }) {
  const color = getBarColor(data?.value);
  return (
    <div className="bg-white border border-gray-200 rounded-xl px-5 py-4 flex items-center gap-4">
      <div className="text-[36px] font-semibold leading-none" style={{ color }}>
        {data.value}{data.value_suffix}
      </div>
      <div className="text-[14px] font-medium text-gray-800">{data.label}</div>
    </div>
  );
}

function ProgressSection({ data }) {
  const items = data?.items || [];
  return (
    <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
      {items.map((item, i) => {
        const label = item.label || item.name;
        const color = getBarColor(item.value);
        return (
          <div key={i} className="flex items-center gap-3 px-4 py-[10px] border-b border-gray-100 last:border-b-0">
            <span className="text-[13px] text-gray-700 w-44 min-w-[120px]">{label}</span>
            <div className="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden">
              <div className="h-full rounded-full" style={{ width: `${item.value}%`, background: color }} />
            </div>
            <span className="text-[13px] font-medium w-9 text-right" style={{ color }}>{item.value}%</span>
            {item.meta && (
              <span className="text-[12px] text-gray-400 w-14 text-right whitespace-nowrap">{item.meta}</span>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default function InsightCardResponse({ data }) {
  if (!data?.sections) return null;

  return (
    <div className="mt-2 w-full flex flex-col gap-2">
      {data.sections.map((section, i) => {
        if (section.type === "KPI") return <KPISection key={i} data={section.data} />;
        if (section.type === "PROGRESS_BAR_CHART") return <ProgressSection key={i} data={section.data} />;
        return null;
      })}
    </div>
  );
}